import React from 'react';
import './TeamCard.css'; // Ensure styles are appropriate

function TeamCard({ team }) {
    return (
        <div className="team-card">
            <img src={team.logo} alt={`${team.name} logo`} className="team-logo" />
            <h3>{team.name}</h3>
            <p>Coach: {team.coach}</p>
            <ul>
                {team.players.map((player, index) => (
                    <li key={index}>{player}</li> // Use index as key here only because player names might not be unique
                ))}
            </ul>
        </div>
    );
}

export default TeamCard;
